import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import MerchantsContent from './merchants.content';

const Merchants: React.FunctionComponent = () => {
  const history = useHistory();

  const selectPartner = useCallback((): void => {
    history.push('partner-contact-form');
  }, [history]);

  const selectDealer = useCallback((): void => {
    history.push('erde-contact-form');
  }, [history]);

  return (
    <MerchantsContent
      selectPartner={selectPartner}
      selectDealer={selectDealer}
    />
  );
};

export default Merchants;
